import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;

import styled, { css } from 'styled-components';
import { CancelIcon } from '@deliveryhero/armor-icons';
import { TAG_DELETE_BEHAVIOUR_OPTIONS, TAG_TYPES } from './constants';
import { transitionDurationInSec } from '../../constants';
import { Typography } from '../Typography';
import { borderRadius, color, reset, spacing, marginAttributes, getComponentOverride, propsBlocker } from '../../system';

var containerStyle = function containerStyle(_ref) {
  var deleteOption = _ref.deleteOption,
      Tag = _ref.theme.componentOverrides.Tag,
      type = _ref.type,
      small = _ref.small;
  var minStatusTagWidth = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        min-width: ", ";\n    "])), spacing(19));
  var result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        justify-content: center;\n        border-color: ", ";\n        border-radius: ", ";\n        height: ", ";\n        padding-left: ", ";\n        padding-right: ", ";\n    "])), color('primary.lighter'), borderRadius('pill'), spacing(small ? 6 : 7), spacing(1), spacing(1));

  switch (type) {
    case TAG_TYPES.APPROVED:
      return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", "", "", "", ""])), result, minStatusTagWidth, Tag.Root.base, Tag.Root.approved);

    case TAG_TYPES.DENIED:
      return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", "", "", "", ""])), result, minStatusTagWidth, Tag.Root.base, Tag.Root.denied);

    case TAG_TYPES.NEW:
      return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", "", "", "", ""])), result, minStatusTagWidth, Tag.Root.base, Tag.Root.new);

    default:
      {
        if (deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ENABLED) {
          return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", "", "", ""])), result, Tag.Root.base, Tag.Root.enabled);
        }

        if (deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.DISABLED) {
          return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", "", ""])), result, Tag.Root.base);
        }

        return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n                ", "\n                ", ";\n                justify-content: flex-end;\n            "])), result, Tag.Root.base);
      }
  }
};

var typographyStyle = function typographyStyle(_ref2) {
  var smallVerticalPadding = _ref2.smallVerticalPadding,
      deleteOption = _ref2.deleteOption,
      Tag = _ref2.theme.componentOverrides.Tag;
  var result = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        && {\n            margin: ", " ", "\n                ", " ", ";\n        }\n    "])), spacing(smallVerticalPadding ? 0.5 : 1), spacing(2), spacing(smallVerticalPadding ? 0.5 : 1), spacing(2));

  if (deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ENABLED) {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            ", "\n            ", "\n            ", "\n        "])), result, Tag.Typography.base, Tag.Typography.enabled);
  }

  return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        ", "\n        ", "\n    "])), result, Tag.Typography.base);
};

var closeIconContainerStyle = function closeIconContainerStyle(_ref3) {
  var deleteOption = _ref3.deleteOption,
      disabled = _ref3.disabled,
      small = _ref3.small;
  var result = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        cursor: ", ";\n        border-color: ", ";\n        border-radius: ", ";\n        height: ", ";\n        width: ", ";\n    "])), disabled ? 'default' : 'pointer', color('primary.lightest'), borderRadius('pill'), spacing(small ? 4 : 5), spacing(small ? 4 : 5));

  if (deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ENABLED) {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: 3px;\n            opacity: 1;\n\n            &:hover {\n                background-color: ", ";\n            }\n        "])), result, disabled ? 'transparent' : color('neutral.02'));
  }

  if (deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ON_HOVER) {
    result = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: 3px;\n            margin-left: 8px;\n            position: absolute;\n        "])), result);

    if (!disabled) {
      result = css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n                ", ";\n                transform: translateX(12px);\n                background-color: ", ";\n\n                &:hover {\n                    background-color: ", ";\n                }\n            "])), result, color('primary.lightest'), color('neutral.02'));
    }

    return result;
  }

  return result;
};

export var TagCloseIconContainer = styled.div.withConfig(propsBlocker)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    outline: none;\n\n    ", "\n"])), closeIconContainerStyle);
export var TagRoot = styled.div.withConfig(propsBlocker)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    ", ";\n    overflow-y: hidden;\n    border-style: solid;\n    border-width: 1px;\n    box-sizing: border-box;\n    cursor: default;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    width: fit-content;\n    user-select: none;\n\n    &:hover ", " {\n        transform: translateX(0);\n        opacity: 1;\n        transition: all ", "s ease;\n    }\n\n    ", ";\n    ", ";\n\n    ", ";\n"])), reset(), TagCloseIconContainer, transitionDurationInSec, containerStyle, marginAttributes, getComponentOverride('Tag'));
export var TagTypography = styled(Typography)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    ", "\n"])), typographyStyle);
export var TagCloseIcon = styled(CancelIcon)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    outline: none;\n\n    height: ", ";\n    width: ", ";\n"])), spacing(2), spacing(2));